<template>
  <div>
    <b-breadcrumb :items="itemsBreadcrumb"></b-breadcrumb>
    <Stats />
  </div>
</template>
<script>
import Stats from "../../components/newEmployeeComponents/misPageComponents/stats.vue";
export default {
  name: "EmployeeMisPage",
  components: {
    Stats,
  },
  data() {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "dashboard",
        },
        {
          text: "Management Reports",
          href: "#",
          active: true,
        },
      ],
    };
  },
};
</script>
